import React, { useEffect } from 'react'
import { Link } from 'gatsby'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Image from '@components/Image'

const MOCKDATA: RealEstateDataPageComponentData = {
  image: "https://images.pexels.com/photos/2078774/pexels-photo-2078774.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  title: "Desde 1994 brindando el mejor servicio.",
  paragraph: "En 1994 decidió emprender su propia inmobiliaria independiente. Planteó su proyecto pensando en las interacciones humanas que incluyen cualquier negociación inmobiliaria como una relación de largo plazo. En ella, el respeto, la transparencia, la constante actitud de servicio y el profesionalismo son vitales.",
  button: {
    link: "nosotros",
    value: "CONOCÉ MÁS",
    border: true
  }
}

const AboutUs_8 = (props:RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { image_gatsby, title, paragraph, button } = isDemo ? MOCKDATA : props

  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])


  return (
    <section className={"about-us h p-y-config "}>
      <Image
        className="w-100 h-100 background-image-absolute no-border "
        objectFit="cover"
        alt="about-us-img"
        image={image_gatsby!!}
      />
      <Container>
        <Row>
          <Col xs={12}>
            <h2>{title}</h2>
            <p>{paragraph}</p>
            {button?.link && <Link className={'btn btn-white ' + (button.border ? 'border' : '')} to={button.link}>{button.value}</Link>}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs_8
